<div class="remote-control-container" [class]="class">
  <div class="lcd-screen">
    <pre #lcdText class="lcd-text" [innerHTML]="terminalDisplayLines"></pre>
  </div>

  <div class="status-screen mb-3">
    <pre
      #statusText
      class="status-text"
      [innerHTML]="computedMarqueeHTML"
    ></pre>
  </div>

  <div class="keypad">
    <button
      *ngFor="let button of buttons"
      (click)="onButtonClick(button)"
      class="keypad-button"
    >
      <img [src]="button.src" [alt]="button.label" />
    </button>
  </div>

  <div class="row d-flex d-md-none mobile-queue-last-button w-100 mt-3">
    <div class="col-4 p-0">
      <div class="fs-4 fw-bold">{{ 'last' | translation }}</div>
      <div class="last-sended-button-container">
        <div class="last-sended-button" *ngIf="mobileLastSendedButton">
          <img
            [src]="mobileLastSendedButton.src"
            [alt]="mobileLastSendedButton.label"
          />
        </div>
      </div>
    </div>
    <div class="col-8 p-0">
      <div class="fs-4 fw-bold">{{ 'queue' | translation }}</div>
      <div class="queued-buttons-container">
        <div class="queued-buttons-content">
          <div class="queued-button" *ngFor="let queued of mobileButtonQueue">
            <img [src]="queued.src" [alt]="queued.label" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
